import { z } from 'zod';
import { SuperAdminSchema } from '../entities/superAdmin.js';
// =========================================================
// /v1/admin/me — super-admin profile (backoffice)
//
// Parallel to /v1/me but gated by `super-admin` role instead of
// `requireTenant`. Needed because super-admins have no TenantUser / Tenant
// scope: `/v1/me*` explicitly 403s them (see backend/src/handlers/me/*).
// Shape mirrors `MePatchRequestSchema` to keep the backoffice form code in
// sync with the tenant-side dashboard.
// =========================================================
// GET /v1/admin/me
export const AdminMeGetResponseSchema = z.object({
    admin: SuperAdminSchema,
});
// PATCH /v1/admin/me
export const AdminMePatchRequestSchema = z
    .object({
    firstName: z.string().min(1).max(60).optional(),
    lastName: z.string().min(1).max(60).optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'At least one field required.' });
export const AdminMePatchResponseSchema = z.object({
    admin: SuperAdminSchema,
});
// POST /v1/admin/me/password — reuses MeChangePasswordRequestSchema verbatim
// (same Cognito ChangePassword call, same policy). No separate schema.
//# sourceMappingURL=admin-me.js.map